export class AddOn {
    passengerName = '';
    passengerType = 'Passenger';
    GUID = '';
  }